import styled from '@emotion/styled';
import { AdAnalyticsVideoIndexKeyFrame } from '@kaizenplatform/hugot-entity';
import { List } from 'immutable';
import { createElement, FC } from 'react';

import AspectRatioFixed from '../../component/primitive/AspectRatioFixed';
import ImageScreen from '../../component/primitive/ImageScreen';

type Props = {
  keyFrames: List<AdAnalyticsVideoIndexKeyFrame>;
  duration: number;
  onUpdatePlayTiming: (timing: number) => void;
  className?: string;
};

const ImagesPerKeyFrames: FC<Props> = ({
  keyFrames,
  duration,
  onUpdatePlayTiming,
  className,
}: {
  keyFrames: List<AdAnalyticsVideoIndexKeyFrame>;
  duration: number;
  onUpdatePlayTiming: (timing: number) => void;
  className?: string;
}) => (
  <Root className={className}>
    {keyFrames.map((keyframe, index) => (
      <ThumbnailWrapper
        key={`keyframes-${index}`}
        style={{
          left: `${
            ((keyframe.start.hours * 60 * 60 + keyframe.start.minutes * 60 + keyframe.start.seconds) / duration) * 100
          }%`,
          transform: `translate3d(${
            ((keyframe.start.hours * 60 * 60 + keyframe.start.minutes * 60 + keyframe.start.seconds) / duration) * 100 >
            90
              ? -100
              : 0
          }%, 0, 0)`,
        }}
        onClick={() =>
          onUpdatePlayTiming(keyframe.start.hours * 60 * 60 + keyframe.start.minutes * 60 + keyframe.start.seconds)
        }
      >
        <ThumbnailFrame aspectRatio={[4, 3]}>
          <ImageScreen src={keyframe.thumbnailImageUrl} scalable={true} />
        </ThumbnailFrame>
      </ThumbnailWrapper>
    ))}
  </Root>
);

const Root = styled('div')({
  position: 'relative',
  height: 45,
});

const ThumbnailWrapper = styled('div')({
  position: 'absolute',
  top: 0,
  width: 60,
  ':hover': {
    zIndex: 10,
    '::after': {
      content: 'none',
    },
  },
  '::after': {
    position: 'absolute',
    bottom: '-5px',
    left: '50%',
    transform: 'translate3d(-50%, 0, 0)',
    content: '""',
    borderStyle: 'solid',
    borderWidth: '5px 5px 0 5px',
    borderColor: '#ccc transparent transparent transparent',
  },
});

const ThumbnailFrame = styled(AspectRatioFixed)({
  width: 60,
});

export default ImagesPerKeyFrames;
